import { defineComponent, reactive, computed } from "vue";
import defaultImg from "@/assets/playturbo/default-image-label.png";
import defaultVideo from "@/assets/playturbo/default-video-label.png";
import defaultSound from "@/assets/playturbo/icon-sound-label.png";
import defaultPsd from "@/assets/playturbo/default-psd.png";
import defaultZip from "@/assets/playturbo/default-zip.png";
import defaultH5 from "@/assets/playturbo/default-h5.png";
import defaultFont from "@/assets/playturbo/default_font.png";
import MediaPlayer from "./multimedia-player.vue";
export default defineComponent({
    components: {
        MediaPlayer: MediaPlayer
    },
    props: {
        // 资产库类型
        type: {
            type: String,
            required: true
        },
        fileSrc: {
            type: String,
            required: true
        },
        posterSrc: {
            type: String,
            default: ""
        },
        width: {
            type: Number,
            default: 200
        },
        height: {
            type: Number,
            default: 200
        },
        status: {
            type: String,
            default: ""
        },
        // 转码中的进度
        progress: {
            type: Number,
            default: 0
        },
        // 资源id
        id: {
            type: String,
            default: ""
        },
        // 是否启用跨域
        crossorigin: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var cardStyle = reactive({
            width: props.width + "px",
            height: props.height + "px"
        });
        var isImage = computed(function() {
            return props.type === "image";
        });
        var isVideo = computed(function() {
            return props.type === "video";
        });
        var isAudio = computed(function() {
            return props.type === "audio";
        });
        var isaImage = computed(function() {
            return props.type === "dragonbone" || props.type === "seqframe";
        });
        var coverSrc = computed(function() {
            switch(props.type){
                case "image":
                    return defaultImg;
                case "audio":
                    return defaultSound;
                case "video":
                    return defaultVideo;
                case "vrecpkg":
                    return defaultZip;
                case "psd":
                    return defaultPsd;
                case "dragonbone":
                case "seqframe":
                case "zip":
                    return defaultZip;
                case "h5":
                    return defaultH5;
                case "font":
                    return defaultFont;
                default:
                    return defaultImg;
            }
        });
        var assetUrl = computed(function() {
            if (isImage.value) {
                return props.fileSrc;
            }
            if (isaImage.value) {
                return props.posterSrc;
            }
            return coverSrc.value;
        });
        // 转码失败重试
        var retryEvent = function(id) {
            emit("retry", id);
        };
        return {
            cardStyle: cardStyle,
            isImage: isImage,
            isVideo: isVideo,
            isAudio: isAudio,
            isaImage: isaImage,
            coverSrc: coverSrc,
            assetUrl: assetUrl,
            retryEvent: retryEvent
        };
    }
});
